<template lang='pug'>
div
  input.is-checkradio(type='radio' :value='radio_value' v-model='local_value' :id="html_id" :disabled='disabled')
  label(:for='html_id'): slot
</template>

<script>

export default {
  name: 'SmRadio',
  data() {
    return {
      html_id: 'radio' + this._uid
    }
  },
  computed: {
    local_value: {
      get() { return this.value },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  props: ['radio_value', 'value', 'disabled']
}
</script>
